<template>
  <div>
    <top-bar />
    <MenuItems :user="this.user" :menuSelected="menuSelectedOffers" />
    <div class="menu-mobile">
      <div class="user-mobile">
        <div class="close-menu" @click="openMenu(false)">
          <img src="@/assets/images/x.svg" />
        </div>
        <div class="openNotifications" @click="showModalPopup('modal_popup_mobileNotifications', true)">
          <div class="unread-notifications">
            <span>2</span>
          </div>
          <img src="@/assets/images/clopotel-alb.svg" />
        </div>

        <div id="modal_popup_mobileNotifications" class="modal-popup">
          <div class="modal-popup-content">
            <a @click="showModalPopup('modal_popup_mobileNotifications', false)" class="close-button">
              <img src="@/assets/images/close-button.svg" />
            </a>
            <div class="notifications">
              <!-- <NotificationsBox :notifications="this.companyMessages" /> -->
            </div>
          </div>
        </div>

        <div>
          <img src="@/assets/images/linie.png" />
        </div>
        <div>
          <img src="@/assets/images/settings.png" />
        </div>
        <div>
          <!-- <a href="#">{{ this.customer.name | titleCase }}</a> -->
        </div>
      </div>
      <MenuItems :user="this.user" :menuSelected="menuSelectedOffers" />
    </div>

    <div class="container-right">
      <div :class="{
        content: true,
      }">
        <div>
          <div class="left">
            <h1>{{ $t(offerType + "sName") }}</h1>
            <p>{{ $t(offerType + "sShortDesc") }}</p>
          </div>
          <div class="right">
            <div class="align-items-start">
              <small>{{ $t("discountFilterLabel") }}</small>
              <select v-model="filters.discount_type" @change="getDedicatedOffers()">
                <option v-for="(entry, index) in discountFilterTypes" :key="index" :value="entry">
                  {{ $t('discountFilter_' + entry) }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <br clear="all" />
        <div v-if="
          this.dedicatedOffers === null || this.dedicatedOffers === undefined
        ">
          <div class="loading">
            <!-- <img src="@/assets/images/loading.gif" /> -->
          </div>
        </div>
        <div>
          <offer-case v-for="(entry, index) in dedicatedOffers" :key="index" :offer="entry" :user="user"
            @showDetails="openOfferDetails" />
        </div>

      </div>
    </div>
    <offer-details-popup :offer="this.selectedOffer" :user="user" />
  </div>
</template>

<script>
import Cookies from "js-cookie";
import TopBar from "../components/company/TopBar.vue";
import MenuItems from "../components/company/MenuItems.vue";
import OfferDetailsPopup from "../components/fragments/OfferDetailsPopup.vue";
import OfferCase from "../components/fragments/OfferCase.vue";
import httpServiceCustomer from "@/http/http-customer.js";

export default {
  name: "Offers",
  components: { TopBar, MenuItems, OfferDetailsPopup, OfferCase },
  data() {
    return {
      offerType: "",
      user: null,
      dedicatedOffers: null,
      selectedOfferId: 0,
      selectedOffer: null,
      perPage: 10000,
      currentPage: 1,
      sortField: "valstdate",
      sortDirection: "desc",
      offersError: null,
      // menuSelected: null,
      filters: {
        discount_type: 'ALL'
      },
      discountFilterTypes: ["DISCOUNT", 'DEDUCTION'],
    };
  },
  methods: {
    getDedicatedOffers() {
      this.dedicatedOffers = null;
      var offersData = "?type=" + this.offerType;
      offersData +=
        "&per_page=" +
        this.perPage +
        "&page=" +
        this.currentPage +
        "&sort=" +
        this.sortDirection;
      if (this.sortDirection === "desc") {
        offersData += "&desc=" + this.sortField;
      } else {
        offersData += "&asc=" + this.sortField;
      }
      if (this.filters.discount_type !== "ALL") {
        offersData += "&discount_type=" + this.filters.discount_type;
      }
      httpServiceCustomer.customerService
        .searchOffers(offersData, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          this.offersError = {
            code: error.response.data,
            description: "Error fetching offers",
          };
        })
        .then((response) => {
          if (response.status == 200) {
            this.dedicatedOffers = response.data;
            // this.invoicesCount = response.headers["x-up-count"]; //["Content-Length"];
          } else if (response.status == 400 || response.status == 403) {
            this.offersError = {
              code: response.data,
              description: "Error fetching offers",
            };
          } else {
            this.offersError = { description: response.description };
          }
        });
    },
    openOfferDetails(offer) {
      this.selectedOfferId = offer.id;
      this.selectedOffer = offer;
      this.showModalPopup("modal_popup_offer", true);
    },
  },
  computed: {
    menuSelectedOffers: function () {
      switch (this.$route.name) {
        case "offer":
        case "offers":
          return { offers: true };
          break;
        case "events":
        case "event":
          return { events: true };
          break;
        case "training":
        case "trainings":
          return { trainings: true };
          break;
        default:
          return { dashboard: true };
      }
    }
  },
  created() {

    this.offerType = this.$route.name;
    switch (this.offerType) {
      case "offer":
      case "offers":
        this.offerType = "offer";
        this.menuSelected = { offers: true };
        break;
      case "events":
      case "event":
        this.offerType = "event";
        this.menuSelected = { events: true };
        break;
      case "training":
      case "trainings":
        this.offerType = "training";
        this.menuSelected = { trainings: true };
        break;
      default:
        this.menuSelected = { dashboard: true };
    }
    this.user = this.getUser();
  },
  mounted() {

    this.getDedicatedOffers();
    // this.selectedOfferId = 0;

    // this.openOfferDetails(15);
  },
};
</script>


<style scoped src="@/assets/styles/beneficiary.css" />
